import { Stack } from '@mui/material'
import { Dispatch, FC, SetStateAction } from 'react'
import { CameraOutlinedIcon, UploadOutlinedIcon } from '../../../../../components/icons'
import { OptionCard } from '../../../Upload/subComponents'

interface UploadOptionsProps {
  setCurrentState: Dispatch<SetStateAction<'camera' | 'upload' | 'options' | 'completed'>>
  setShowInstructions: (value: boolean) => void
}

export const BrowserOptions: FC<UploadOptionsProps> = ({
  setCurrentState,

}) => {
  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={3}>
      <OptionCard
        icon={<CameraOutlinedIcon sx={{ fontSize: '2rem' }} />}
        title={'Take a photo'}
        description={'Capture the result with your device'}
        onClick={() => setCurrentState('camera')}
      />
      <OptionCard
        icon={<UploadOutlinedIcon sx={{ fontSize: '2rem' }} />}
        title={'Upload image'}
        description={'Upload image from your gallery'}
        onClick={() => setCurrentState('upload')}
      />
    </Stack>
  )
}
